// src/pages/FacturacionPresupuestos/HistorialDocumentosTab.js
import React, { useState } from 'react';
import { 
    FaFileInvoiceDollar, 
    FaPlus, 
    FaSearch, 
    FaEdit, 
    FaCopy, 
    FaExchangeAlt, 
    FaWhatsapp, 
    FaEnvelope, 
    FaEnvelopeOpen,
    FaCheckDouble,
    FaInfoCircle,
    FaCheckCircle,
    FaTimes,
    FaFilePdf,
    FaTrash, 
    FaPrint,
    FaClock,
    FaSyncAlt,
    FaCalendarAlt,
    FaBolt
} from 'react-icons/fa';
import './GestionTabs.css';

const HistorialDocumentosTab = ({
    documentos = [],
    onNuevoDocumento,
    onEditarDocumento,
    onDuplicarDocumento,
    onConvertirDocumento,
    onEliminarDocumento,
    onCompartirWhatsApp,
    onAbrirSendGrid,
    onImprimirDocumento,
    onEjecutarEnviosManual
}) => {
    const [filtroTipo, setFiltroTipo] = useState('todos');
    const [filtroEstado, setFiltroEstado] = useState('todos');
    const [busqueda, setBusqueda] = useState('');
    const [docDetalleEnvio, setDocDetalleEnvio] = useState(null);

    const documentosFiltrados = documentos.filter(doc => {
        const coincideTipo = filtroTipo === 'todos' || doc.tipoDocumento === filtroTipo;
        const coincideEstado = filtroEstado === 'todos' || doc.estado === filtroEstado;
        const texto = `${doc.folio || ''} ${doc.cliente?.nombre || ''} ${doc.cliente?.rfc || ''} ${doc.tituloDocumento || ''}`.toLowerCase();
        const coincideBusqueda = !busqueda || texto.includes(busqueda.toLowerCase());
        return coincideTipo && coincideEstado && coincideBusqueda;
    });

    const getBadgeClass = (estado) => {
        const est = (estado || 'borrador').toLowerCase();
        if (est === 'enviado') return 'zen-status-badge enviado';
        if (est === 'programado') return 'zen-status-badge programado';
        if (est === 'recurrente') return 'zen-status-badge recurrente';
        if (est === 'aceptado' || est === 'pagado') return 'zen-status-badge aceptado';
        if (est === 'cancelado' || est === 'vencido') return 'zen-status-badge cancelado';
        return 'zen-status-badge borrador';
    };

    const formatearFechaSimple = (fechaStr) => {
        if (!fechaStr) return '';
        try {
            const [y, m, d] = String(fechaStr).split('T')[0].split('-').map(Number);
            const dt = new Date(y, m - 1, d, 12, 0, 0);
            return dt.toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' });
        } catch {
            return fechaStr;
        }
    };

    return (
        <div className="gestion-tab-container">
            {/* Header */}
            <div className="gestion-tab-header">
                <div className="gestion-tab-title-group">
                    <h2>
                        <FaFileInvoiceDollar style={{ color: '#2b5329' }} /> Historial de Documentos Emitidos
                    </h2>
                    <p>
                        Presupuestos formales, notas de pago y remisiones de cobro registradas en la plataforma.
                    </p>
                </div>
                <div className="gestion-tab-actions">
                    {onEjecutarEnviosManual && (
                        <button 
                            type="button" 
                            className="btn-primary-zen"
                            style={{ background: '#d97706', color: '#ffffff' }}
                            onClick={onEjecutarEnviosManual}
                            title="Verificar y despachar inmediatamente los envíos programados y recurrentes pendientes"
                        >
                            <FaBolt /> Despachar Envíos Programados
                        </button>
                    )}
                    <button 
                        type="button" 
                        className="btn-primary-zen"
                        onClick={() => onNuevoDocumento('presupuesto')}
                    >
                        <FaPlus /> Nuevo Presupuesto
                    </button>
                    <button 
                        type="button" 
                        className="btn-primary-zen"
                        style={{ background: '#0284c7' }}
                        onClick={() => onNuevoDocumento('remision')}
                    >
                        <FaPlus /> Nueva Remisión
                    </button>
                    <button 
                        type="button" 
                        className="btn-primary-zen"
                        style={{ background: '#0f766e' }}
                        onClick={() => onNuevoDocumento('pago')}
                    >
                        <FaPlus /> Nota de Pago
                    </button>
                </div>
            </div>

            {/* Barra de Filtros */}
            <div className="gestion-filter-bar">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
                    <FaSearch style={{ color: '#94a3b8' }} />
                    <input 
                        type="text"
                        className="gestion-search-input"
                        placeholder="Buscar por folio, cliente, RFC o concepto..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                </div>
                <select 
                    className="gestion-filter-select"
                    value={filtroTipo}
                    onChange={(e) => setFiltroTipo(e.target.value)}
                >
                    <option value="todos">Todos los Documentos</option>
                    <option value="presupuesto">Presupuestos</option>
                    <option value="pago">Notas de Pago</option>
                    <option value="remision">Remisiones / Cobros</option>
                </select>
                <select 
                    className="gestion-filter-select"
                    value={filtroEstado}
                    onChange={(e) => setFiltroEstado(e.target.value)}
                >
                    <option value="todos">Todos los Estados</option>
                    <option value="borrador">Borrador</option>
                    <option value="programado">Programados</option>
                    <option value="recurrente">Recurrentes</option>
                    <option value="enviado">Enviado</option>
                    <option value="aceptado">Aceptado</option>
                    <option value="pagado">Pagado</option>
                    <option value="cancelado">Cancelado</option>
                </select>
            </div>

            {/* Tabla de Documentos */}
            <div className="gestion-table-wrapper">
                <table className="gestion-zen-table">
                    <thead>
                        <tr>
                            <th>Folio</th>
                            <th>Tipo</th>
                            <th>Cliente / Receptor</th>
                            <th>Fecha</th>
                            <th>Total</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {documentosFiltrados.length === 0 ? (
                            <tr>
                                <td colSpan="7" style={{ textAlign: 'center', padding: '32px', color: '#94a3b8' }}>
                                    No se encontraron documentos en el historial. Haz clic en "Nuevo Presupuesto" o "Nueva Remisión" para comenzar.
                                </td>
                            </tr>
                        ) : (
                            documentosFiltrados.map((doc) => {
                                const totalDoc = (doc.conceptos || []).reduce((acc, c) => acc + ((Number(c.cantidad) || 0) * (Number(c.precioUnitario) || 0)), 0);
                                const totalConIva = doc.aplicaIva ? totalDoc * 1.16 : totalDoc;
                                const tipoLabel = doc.tipoDocumento === 'presupuesto' ? 'Presupuesto' :
                                                  doc.tipoDocumento === 'pago' ? 'Nota de Pago' : 'Remisión';

                                return (
                                    <tr key={doc.id}>
                                        <td style={{ fontWeight: 700, color: '#1e293b' }}>
                                            {doc.folio || 'S/F'}
                                        </td>
                                        <td>
                                            <span style={{ fontSize: '12px', fontWeight: 600, color: '#475569' }}>
                                                {tipoLabel}
                                            </span>
                                        </td>
                                        <td>
                                            <div style={{ fontWeight: 600 }}>{doc.cliente?.nombre || 'Sin Cliente'}</div>
                                            <div style={{ fontSize: '11px', color: '#64748b' }}>{doc.cliente?.rfc || doc.cliente?.telefono || 'Sin datos de contacto'}</div>
                                        </td>
                                        <td>
                                            {doc.fechaEmision || new Date().toISOString().split('T')[0]}
                                        </td>
                                        <td style={{ fontWeight: 700, color: '#2b5329' }}>
                                            ${totalConIva.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </td>
                                        <td>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    <span className={getBadgeClass(doc.estado)}>
                                                        {doc.estado === 'programado' && <FaClock style={{ marginRight: '4px' }} />}
                                                        {doc.estado === 'recurrente' && <FaSyncAlt style={{ marginRight: '4px' }} />}
                                                        {doc.estado || 'borrador'}
                                                    </span>
                                                    {(doc.ultimoEnvio || doc.programacionEnvio) && (
                                                        <button
                                                            type="button"
                                                            onClick={() => setDocDetalleEnvio(doc)}
                                                            style={{
                                                                background: 'none',
                                                                border: 'none',
                                                                color: '#0284c7',
                                                                cursor: 'pointer',
                                                                padding: '0 2px',
                                                                fontSize: '13px'
                                                            }}
                                                            title="Ver bitácora técnica de entrega y trazabilidad"
                                                        >
                                                            <FaInfoCircle />
                                                        </button>
                                                    )}
                                                </div>

                                                {/* Estado para modalidad Programado (Punto 2) */}
                                                {doc.estado === 'programado' && (
                                                    <div>
                                                        <span 
                                                            style={{ 
                                                                display: 'inline-flex', 
                                                                alignItems: 'center', 
                                                                gap: '4px', 
                                                                background: '#fffbeb', 
                                                                color: '#b45309', 
                                                                border: '1px solid #fde68a', 
                                                                borderRadius: '10px', 
                                                                padding: '2px 8px', 
                                                                fontSize: '10.5px', 
                                                                fontWeight: 600 
                                                            }}
                                                            title={`Envío programado para el ${formatearFechaSimple(doc.programacionEnvio?.fechaProgramada || doc.ultimoEnvio?.fechaProgramada)} a las ${doc.programacionEnvio?.horaProgramada || doc.ultimoEnvio?.horaProgramada || '09:00'} hrs (CST)`}
                                                        >
                                                            <FaClock style={{ color: '#d97706' }} /> 
                                                            {doc.programacionEnvio?.fechaProgramada || doc.ultimoEnvio?.fechaProgramada 
                                                                ? `${formatearFechaSimple(doc.programacionEnvio?.fechaProgramada || doc.ultimoEnvio?.fechaProgramada)} • ${doc.programacionEnvio?.horaProgramada || doc.ultimoEnvio?.horaProgramada || '09:00'} hrs`
                                                                : 'Programado'}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Estado para modalidad Recurrente (Punto 3) */}
                                                {doc.estado === 'recurrente' && (
                                                    <div>
                                                        <span 
                                                            style={{ 
                                                                display: 'inline-flex', 
                                                                alignItems: 'center', 
                                                                gap: '4px', 
                                                                background: '#f0fdf4', 
                                                                color: '#15803d', 
                                                                border: '1px solid #bbf7d0', 
                                                                borderRadius: '10px', 
                                                                padding: '2px 8px', 
                                                                fontSize: '10.5px', 
                                                                fontWeight: 600 
                                                            }}
                                                            title={`Envío recurrente activo. Se emitirá automáticamente en cada ciclo con fecha y folio actualizados.`}
                                                        >
                                                            <FaSyncAlt style={{ color: '#16a34a' }} /> 
                                                            {(doc.programacionEnvio?.frecuencia || 'mensual').charAt(0).toUpperCase() + (doc.programacionEnvio?.frecuencia || 'mensual').slice(1)} • Próx: {formatearFechaSimple(doc.programacionEnvio?.fechaCorte || doc.ultimoEnvio?.fechaCorte) || `Día ${doc.programacionEnvio?.diaCorte || 1}`}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Indicador de Lectura de Correo (Solo para enviados) */}
                                                {doc.estado === 'enviado' && (
                                                    <div>
                                                        {doc.leido ? (
                                                             <span 
                                                                 style={{ 
                                                                     display: 'inline-flex', 
                                                                     alignItems: 'center', 
                                                                     gap: '4px', 
                                                                     background: '#eff6ff', 
                                                                     color: '#1d4ed8', 
                                                                     border: '1px solid #bfdbfe', 
                                                                     borderRadius: '10px', 
                                                                     padding: '2px 7px', 
                                                                     fontSize: '10.5px', 
                                                                     fontWeight: 700 
                                                                 }}
                                                                 title={`Correo abierto y leído por el receptor ${doc.fechaLectura ? 'el ' + new Date(doc.fechaLectura).toLocaleString('es-MX') : ''} (${doc.lecturasCount || 1} veces)`}
                                                             >
                                                                 <FaEnvelopeOpen style={{ color: '#2563eb' }} /> Leído {doc.lecturasCount && doc.lecturasCount > 1 ? `(${doc.lecturasCount})` : ''}
                                                             </span>
                                                         ) : (
                                                             <span 
                                                                 style={{ 
                                                                     display: 'inline-flex', 
                                                                     alignItems: 'center', 
                                                                     gap: '4px', 
                                                                     background: '#f8fafc', 
                                                                     color: '#64748b', 
                                                                     border: '1px solid #e2e8f0', 
                                                                     borderRadius: '10px', 
                                                                     padding: '2px 7px', 
                                                                     fontSize: '10.5px' 
                                                                 }}
                                                                 title="Correo entregado. Pendiente de apertura por el receptor."
                                                             >
                                                                 <FaEnvelope style={{ color: '#94a3b8' }} /> No leído aún
                                                             </span>
                                                         )}
                                                    </div>
                                                )}

                                                {/* Subtexto con destinatario real de entrega */}
                                                {(doc.ultimoEnvio?.destinatario || doc.programacionEnvio?.destinatario) && (
                                                    <div style={{ fontSize: '10px', color: '#64748b', lineHeight: 1.25 }}>
                                                        <div>Para: <strong style={{ color: '#0f172a' }}>{doc.ultimoEnvio?.destinatario || doc.programacionEnvio?.destinatario}</strong></div>
                                                        <div style={{ color: '#94a3b8' }}>De: {doc.ultimoEnvio?.remitente || 'domushabitat2025@hotmail.com'}</div>
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="row-actions-group">
                                                <button 
                                                    type="button" 
                                                    className="btn-row-action"
                                                    onClick={() => onEditarDocumento(doc)}
                                                    title="Editar en Lienzo"
                                                >
                                                    <FaEdit /> Editar
                                                </button>
                                                <button 
                                                    type="button" 
                                                    className="btn-row-action"
                                                    onClick={() => onDuplicarDocumento(doc)}
                                                    title="Duplicar / Clonar"
                                                >
                                                    <FaCopy />
                                                </button>
                                                {doc.tipoDocumento === 'presupuesto' && (
                                                    <button 
                                                        type="button" 
                                                        className="btn-row-action"
                                                        onClick={() => onConvertirDocumento(doc, 'remision')}
                                                        title="Convertir a Remisión de Cobro"
                                                    >
                                                        <FaExchangeAlt /> Remisión
                                                    </button>
                                                )}
                                                <button 
                                                    type="button" 
                                                    className="btn-row-action whatsapp"
                                                    onClick={() => onCompartirWhatsApp(doc)}
                                                    title="Compartir por WhatsApp"
                                                >
                                                    <FaWhatsapp />
                                                </button>
                                                <button 
                                                    type="button" 
                                                    className="btn-row-action sendgrid"
                                                    onClick={() => onAbrirSendGrid(doc)}
                                                    title="Enviar por Correo Electrónico"
                                                >
                                                    <FaEnvelope />
                                                </button>
                                                <button 
                                                    type="button" 
                                                    className="btn-row-action delete"
                                                    onClick={() => onEliminarDocumento(doc.id)}
                                                    title="Eliminar Documento"
                                                >
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        )}
                    </tbody>
                </table>
            </div>

            {/* Modal de Bitácora Técnica de Entrega y Lectura de Correo */}
            {docDetalleEnvio && (
                <div className="modal-sendgrid-overlay" onClick={() => setDocDetalleEnvio(null)}>
                    <div className="modal-sendgrid-container" style={{ maxWidth: '520px' }} onClick={(e) => e.stopPropagation()}>
                        <div className="modal-sendgrid-header">
                            <h3 className="modal-sendgrid-title">
                                <FaInfoCircle style={{ color: '#0284c7' }} /> Bitácora Técnica de Entrega de Correo
                            </h3>
                            <button type="button" className="modal-sendgrid-close" onClick={() => setDocDetalleEnvio(null)}>
                                <FaTimes />
                            </button>
                        </div>
                        <div className="modal-sendgrid-body" style={{ fontSize: '13px' }}>
                            <div style={{ background: '#f8fafc', padding: '14px', borderRadius: '8px', border: '1px solid #e2e8f0', marginBottom: '14px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                                    <span style={{ color: '#64748b' }}>Folio Oficial:</span>
                                    <strong style={{ color: '#1e3a8a', fontFamily: 'monospace' }}>{docDetalleEnvio.folio || 'S/F'}</strong>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                                    <span style={{ color: '#64748b' }}>Cliente Receptor:</span>
                                    <strong>{docDetalleEnvio.cliente?.nombre || 'Público en General'}</strong>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span style={{ color: '#64748b' }}>Tipo de Documento:</span>
                                    <span style={{ textTransform: 'capitalize', fontWeight: 600 }}>{docDetalleEnvio.tipoDocumento}</span>
                                </div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #f1f5f9', paddingBottom: '6px' }}>
                                    <span style={{ color: '#64748b' }}>Correo Destinatario:</span>
                                    <strong style={{ color: '#0f172a' }}>{docDetalleEnvio.ultimoEnvio?.destinatario || docDetalleEnvio.cliente?.email || 'N/D'}</strong>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #f1f5f9', paddingBottom: '6px' }}>
                                    <span style={{ color: '#64748b' }}>Remitente Verificado:</span>
                                    <span style={{ color: '#15803d', fontWeight: 600 }}>{docDetalleEnvio.ultimoEnvio?.remitente || 'domushabitat2025@hotmail.com'}</span>
                                </div>
                                {(docDetalleEnvio.estado === 'programado' || docDetalleEnvio.programacionEnvio?.modo === 'programado') && (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #f1f5f9', paddingBottom: '6px' }}>
                                        <span style={{ color: '#64748b' }}>Calendarización Programada:</span>
                                        <span style={{ background: '#fef3c7', color: '#b45309', padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: 700 }}>
                                            <FaClock /> {formatearFechaSimple(docDetalleEnvio.programacionEnvio?.fechaProgramada || docDetalleEnvio.ultimoEnvio?.fechaProgramada)} a las {docDetalleEnvio.programacionEnvio?.horaProgramada || docDetalleEnvio.ultimoEnvio?.horaProgramada || '09:00'} hrs
                                        </span>
                                    </div>
                                )}
                                {(docDetalleEnvio.estado === 'recurrente' || docDetalleEnvio.programacionEnvio?.modo === 'recurrente') && (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #f1f5f9', paddingBottom: '6px' }}>
                                        <span style={{ color: '#64748b' }}>Modalidad Recurrente:</span>
                                        <span style={{ background: '#f0fdf4', color: '#15803d', padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: 700 }}>
                                            <FaSyncAlt /> {(docDetalleEnvio.programacionEnvio?.frecuencia || 'mensual').toUpperCase()} • Corte: {formatearFechaSimple(docDetalleEnvio.programacionEnvio?.fechaCorte || docDetalleEnvio.ultimoEnvio?.fechaCorte) || `Día ${docDetalleEnvio.programacionEnvio?.diaCorte || 1}`}
                                        </span>
                                    </div>
                                )}
                                {docDetalleEnvio.estado === 'enviado' && (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #f1f5f9', paddingBottom: '6px' }}>
                                        <span style={{ color: '#64748b' }}>Estado HTTP API:</span>
                                        <span style={{ background: '#dcfce7', color: '#166534', padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: 700 }}>
                                            {docDetalleEnvio.ultimoEnvio?.statusCode || 202} Aceptado por Servidor de Correo
                                        </span>
                                    </div>
                                )}
                                <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #f1f5f9', paddingBottom: '6px' }}>
                                    <span style={{ color: '#64748b' }}>Archivo PDF Adjunto:</span>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#dc2626', fontWeight: 600 }}>
                                        <FaFilePdf /> Sí, generado automáticamente
                                    </span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #f1f5f9', paddingBottom: '6px' }}>
                                    <span style={{ color: '#64748b' }}>Estatus de Lectura (Open Tracking):</span>
                                    {docDetalleEnvio.leido ? (
                                        <span style={{ color: '#1d4ed8', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <FaEnvelopeOpen /> Abierto y Leído ({docDetalleEnvio.lecturasCount || 1} veces)
                                        </span>
                                    ) : (
                                        <span style={{ color: '#64748b', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <FaEnvelope /> Entregado (Pendiente de apertura)
                                        </span>
                                    )}
                                </div>
                                {docDetalleEnvio.ultimoEnvio?.messageId && (
                                    <div style={{ borderBottom: '1px solid #f1f5f9', paddingBottom: '6px' }}>
                                        <span style={{ color: '#64748b', display: 'block', marginBottom: '2px' }}>Identificador Oficial de Transmisión (Message-ID):</span>
                                        <code style={{ fontSize: '11px', background: '#f1f5f9', padding: '2px 6px', borderRadius: '4px', wordBreak: 'break-all' }}>
                                            {docDetalleEnvio.ultimoEnvio.messageId}
                                        </code>
                                    </div>
                                )}
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span style={{ color: '#64748b' }}>Fecha de Emisión / Despacho:</span>
                                    <span>{docDetalleEnvio.ultimoEnvio?.fecha ? new Date(docDetalleEnvio.ultimoEnvio.fecha).toLocaleString('es-MX') : 'Reciente'}</span>
                                </div>
                            </div>
                        </div>
                        <div className="modal-sendgrid-footer">
                            <button type="button" className="btn-modal-send" onClick={() => setDocDetalleEnvio(null)}>
                                Entendido
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default HistorialDocumentosTab;
